<template>
    <div class="gallery-autoplay-toggle" v-if="galleryVersion === 'modern'" @click='toggleAutoplay()' :class="{'gallery-autoplay-toggle--modern' : (galleryVersion == 'modern')}">
        <label id="autoplayCheckboxLabel" for="autoplayCheckbox" v-html="labels ? labels.autoplayFilterLabel : null" class="gallery-autoplay-toggle__label"></label>
        <input type="checkbox" aria-labelledby="autoplayCheckboxLabel" id="autoplayCheckbox" class="gallery-autoplay-toggle__button" role="checkbox" :class="autoplay ? 'toggle-on' : 'toggle-off' " :checked="autoplay" :aria-checked="autoplay" tabindex="0">
        <span class="checkmark"></span>  
    </div>

    <div class="gallery-autoplay-toggle" v-else-if="galleryVersion === 'legacy'">
        <label id="autoplayCheckboxLabel" for="autoplayCheckbox" v-html="labels ? labels.autoplayFilterLabel : null" class="gallery-autoplay-toggle__label"></label>
        <div aria-labelledby="autoplayCheckboxLabel" id="autoplayCheckbox" @click='toggleAutoplay()' class="gallery-autoplay-toggle__button" role="checkbox" :class="autoplay ? 'toggle-on' : 'toggle-off' " :aria-checked="autoplay ? 'true' : 'false'" tabindex="0" @keydown="onSwitchKeyDown">
            <span class="switch">
                <span v-show="autoplay" aria-hidden="true" v-html="labels ? labels.autoplayFilterOnText : null" class="on"></span>
                <span v-show="autoplay == false" aria-hidden="true" v-html="labels ? labels.autoplayFilterOffText : null" class="off"></span>
                <span class="switch-slide"></span>
            </span>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';

    export default {
        name: 'GalleryAutoplayToggle',
        data() {
            return {
            }
        },

        computed: {
            ...mapState('gallery', [
                'autoplay',
                'galleryVersion',
            ]),

            ...mapState('translations', [
                'labels',
            ])
        },

        methods: {
            ...mapMutations('gallery', [
                'toggleAutoplay',
            ]),

            onSwitchKeyDown(event) {
                if (event.code === 'Space' || event.key === 'Enter') {
                    event.preventDefault();
                    this.toggleAutoplay();
                }
            }
        }
    }
</script>